import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ComplexData from './ComplexData';
import ComplexViewSkatS from './ComplexViewSkatS';
import '../../../styles/ModalContent.css';
import { useState } from 'react';
import ComplexGraphs from './ComplexGraphs';
import ComplexStatistic from './ComplexStatistic';

const ModalContentSpeed = props => {
    const { roles } = props
    const [key, setKey] = useState(roles.includes('manager') ? 'statistic' : 'home');
    console.log(props.complex)
    const type = props.complex.tags.find((c) => c.tag === 'type')
    console.log(type)
    return (
        <Tabs
            defaultActiveKey="profile"
            id="uncontrolled-tab-example"
            className="mb-3"
            onSelect={(k) => setKey(k)}
            activeKey={key}
        >
            {roles && !roles.includes('manager') ?
                <Tab eventKey="home" title="Данные">
                    <ComplexData complex={props.complex} />
                </Tab>
                : null
            }
            {roles && !roles.includes('manager') ?
                <Tab eventKey="graphs" title="Графики">
                    <ComplexGraphs complex={props.complex} />
                </Tab>
                : null
            }

            <Tab eventKey="statistic" title="Статистика">
                <ComplexStatistic complex={props.complex} style={props.style} />
            </Tab>

        </Tabs>
    )

}

export default ModalContentSpeed